<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head.head-border
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb
        el-col.pt-5.text-right(:span="15")
          el-button(v-if="user.role == 3 ? true : ops.indexOf('add') > -1" type="primary" size="mini" @click="goto('/warehouse/idle_materials_detail/1/1')") 新增
    div(style="height:70px")
    el-main.white.pa-3.ma-4
      el-row.py-3(v-if="!flag" type="flex" justify="center")
        el-col(:span="13")
          el-row(type="flex" justify="center" :gutter="10")
            el-col(:span="13")
              el-input.w-100(v-model="list.key_name" placeholder="请输入物料名称/物料编码" clearable)
            el-col(:span="11")
              el-button(type="primary" @click="search(1)" :loading="loading") 查询
              el-button(type="text" @click="flag = true" :loading="loading") 高级搜索
      div(v-else)
        el-row.py-3(type="flex" justify="center")
          el-col(:span="22")
            el-row(type="flex" justify="center" :gutter="10")
              el-col(:span="6")
                el-input.w-100(v-model="list.name_material" placeholder="物料名称" clearable)
              el-col(:span="6")
                el-input.w-100(v-model="list.code_material" placeholder="物料编码" clearable)
              el-col(:span="6")
                el-input.w-100(v-model="list.source_code" placeholder="录入人" clearable)
              el-col(:span="6")
                el-date-picker.w-100(v-model="time" type="daterange" align="right" unlink-panels range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions1")
        el-row.py-1(type="flex" justify="center")
          el-col(:span="12")
            el-row(type="flex" justify="center")
              el-col(:span="10")
                el-button(type="primary" @click="search(2)" :loading="loading") 查询
                el-button(type="text" @click="flag = false" :loading="loading") 收起
      el-table(:data="data" v-loading="loading" size="mini")
        el-table-column(prop="code_material" label="物料编码" min-width="120" show-overflow-tooltip)
        el-table-column(prop="name_material" label="物料名称" show-overflow-tooltip)
        el-table-column(prop="spec_material" label="规格" show-overflow-tooltip)
        el-table-column(prop="type_material" label="型号" show-overflow-tooltip)
        el-table-column(prop="unit_material" label="单位" width="50")
        el-table-column(prop="num" label="结存数量" show-overflow-tooltip)
        el-table-column(prop="price" label="含税单价" show-overflow-tooltip)
        el-table-column(prop="money" label="价税合计" show-overflow-tooltip)
        el-table-column(prop="address" label="存放地点" show-overflow-tooltip)
        el-table-column(label="操作")
          template(slot-scope="scope")
            el-button(v-if="user.role == 3 ? true : ops.indexOf('edit') > -1" size="mini" type="primary" plain @click="goto('/warehouse/idle_materials_detail/'+scope.row.id+'/2')") 编辑
      el-pagination.my-4.text-center(@size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="list.page_num" :page-sizes="page_sizes" :page-size="list.page_size" layout="total,sizes, prev, pager, next, jumper" :total="count" background)
</template>
<script>
export default {
  data() {
    return {
      flag: false,
      h: "",
      loading: false,
      list: {
        code_material: null,
        creator: null,
        end_date: null,
        name_material: null,
        start_date: null,
        key_name: null,
        page_num: 1,
        page_size: 10
      },
      count: 0,
      data: [],
      time: ""
    };
  },
  methods: {
    search(type) {
      if (type == 2) {
        this.list.key_name = null;
        if (this.time) {
          this.list.start_date = this.time[0];
          this.list.end_date = this.time[1];
        } else {
          this.list.start_date = null;
          this.list.end_date = null;
        }
      } else {
        this.list.name_material = null;
        this.list.code_material = null;
        this.list.creator = null;
        this.list.start_date = null;
        this.list.end_date = null;
      }
      this.list.page_num = 1;
      this.$router.push({
        path: this.$route.path,
        query: this.list
      });
    },
    handleSizeChange(e) {
      this.list.page_size = e;
      this.$router.push({
        path: this.$route.path,
        query: this.list
      });
    },
    handleCurrentChange(e) {
      this.list.page_num = e;
      this.$router.push({
        path: this.$route.path,
        query: this.list
      });
    },
    async getList() {
      this.loading = true;
      let res = await this.$api.idle_materials.getList(this.list);
      this.loading = false;
      if (res) {
        this.data = res.data;
      }
    },
    initList() {
      let data = this.$route.query;
      if (JSON.stringify(data) != "{}") {
        this.list = this.$utils.cloneDeep(data);
        if (data.page_num) {
          this.list.page_num = parseInt(data.page_num);
        }
        if (data.page_size) {
          this.list.page_size =
            this.page_sizes.indexOf(parseInt(data.page_size)) > -1
              ? parseInt(data.page_size)
              : this.page_sizes[0];
        }
        if (this.list.class_material && this.classify == false) {
          this.classify = JSON.parse(
            localStorage.getItem("PurchaseDemand_class")
          );
        }
        if (
          this.list.name_material ||
          this.list.code_material ||
          this.list.creator ||
          this.list.start_date ||
          this.list.end_date
        ) {
          this.flag = true;
        }
        if (this.list.start_date && this.list.end_date) {
          this.time = [this.list.start_date, this.list.end_date];
        }
      }
    },
    init() {
      this.initList();
      this.getList();
    }
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  watch: {
    $route: {
      handler: "init",
      immediate: true
    }
  }
};
</script>